/* Don’t define twice if the section appears more than once  */
if (!customElements.get('youtube-video-grid')) {

  class YouTubeVideoGrid extends HTMLElement {

    connectedCallback() {
      this.restoreBasicThumbnails();

      this.attachHandlers();
      this.upgradeThumbnails();
    }

    /*
     * For each card, check if a high-resolution thumbnail exists.
     * checks the image dimensions to ensure it's not a placeholder.
    */
   restoreBasicThumbnails() {
    this.querySelectorAll('.youtube-video-card .youtube-thumbnail').forEach(img => {
      // If the src is still the transparent pixel, swap it with the real URL
      if (img.src.includes('data:image/gif') && img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
  }

    upgradeThumbnails() {
      this.querySelectorAll('.youtube-video-card').forEach(card => {
        const img      = card.querySelector('.youtube-thumbnail');
        if (!img) return;
  
        const maxUrl   = img.dataset.maxresThumbnail;
        const midUrl   = img.dataset.midresThumbnail;
        const fallback = img.dataset.fallbackThumbnail;  // hqdefault
  
        /** helper that tries a URL and resolves with the first that is real */
        const probe = url => new Promise(ok => {
          if (!url) return ok(false);
          const test = new Image();
          test.src   = url;
          test.onload = () => ok(test.naturalWidth > 120 ? url : false);
          test.onerror = () => ok(false);
        });
  
        /* chain: max‑res → sd → already‑displayed HQ */
       (async () => {
        // Probe higher res images
        const chosen = await probe(maxUrl) || await probe(midUrl) || false;
        
        // If we found a better one, use it. 
        if (chosen) {
            img.src = chosen;
        } else {
            // If we didn't find a better one, AND the current src is still the placeholder
            // ensure we at least show the fallback.
            if (img.src.includes('data:image/gif')) {
                img.src = fallback;
            }
        }
      })();
  
        /* if *all* probes fail AND hqdefault itself 404s, restore the fallback */
        img.onerror = function () {
          if (this.src !== fallback) this.src = fallback;
        };
      });
    }

    /* -------------------------------------------------- */
    /* SET UP CLICK HANDLERS ON EVERY CARD IN THIS GRID  */
    /* -------------------------------------------------- */
    attachHandlers() {
      this.querySelectorAll('.youtube-video-card').forEach(card => {
        const id = this.extractId(card.dataset.videoUrl);
        if (!id) return;

        const clickTarget1 = card.querySelector('.youtube-thumbnail-wrapper');
        const clickTarget2 = card.querySelector('.youtube-play-button');
        const play = () => this.play(card, id);

        if (clickTarget1) clickTarget1.addEventListener('click', play);
        if (clickTarget2) clickTarget2.addEventListener('click', play);
      });
    }

    /* ---------- HELPERS ---------- */
    extractId(url) {
      if (!url) return null;
      const m = url.match(
        /^.*(?:youtu\.be\/|v\/|embed\/|watch\?v=|watch\?.+&v=)([^#&?]{11}).*/
      );
      return m ? m[1] : null;
    }

    /* -------------------------------------------------- */
    /* PLAY A VIDEO – GLOBAL “ONE-AT-A-TIME” LOGIC HERE  */
    /* -------------------------------------------------- */
    play(card, id) {

      /* 1️⃣ Stop whatever is already playing on the page (if any) */
      if (YouTubeVideoGrid.currentCard) {
        const thumbWrapper = YouTubeVideoGrid.currentCard.querySelector('.youtube-thumbnail-wrapper');
        if (thumbWrapper) {
          thumbWrapper.style.display = '';
        }

        if (YouTubeVideoGrid.currentIframe) {
          YouTubeVideoGrid.currentIframe.remove();
        }

        YouTubeVideoGrid.currentCard = null;
        YouTubeVideoGrid.currentIframe = null;
      }

      /* 2️⃣ Hide thumbnail of the clicked card */
      const thumbWrapper = card.querySelector('.youtube-thumbnail-wrapper');
      if (thumbWrapper) {
        thumbWrapper.style.display = 'none';
      }

      /* 3️⃣ Insert new iframe */
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.frameBorder = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      card.querySelector('.youtube-video-container').appendChild(iframe);

      /* 4️⃣ Remember what’s playing (static = shared by *all* grids) */
      YouTubeVideoGrid.currentCard = card;
      YouTubeVideoGrid.currentIframe = iframe;
    }
  }

  /* Static properties hold the single active video for the whole page */
  YouTubeVideoGrid.currentCard = null;
  YouTubeVideoGrid.currentIframe = null;

  customElements.define('youtube-video-grid', YouTubeVideoGrid);
}